import React__default from 'react';
import Column from '../atoms/Column.mjs';
import Typography from '../atoms/Typography.mjs';

/**
 * Helper component for a common text layout pattern
 */ const TextColumn = ({ header, body, helper, align })=>/*#__PURE__*/ React__default.createElement(Column, {
        gap: 4
    }, /*#__PURE__*/ React__default.createElement(Typography, {
        variant: "header",
        align: align
    }, header), body && /*#__PURE__*/ React__default.createElement(Typography, {
        align: align
    }, body), helper && /*#__PURE__*/ React__default.createElement(Typography, {
        variant: "helper",
        align: align
    }, helper));

export { TextColumn as default };
//# sourceMappingURL=TextColumn.mjs.map
